

export const goodsManageListNewData = [
  {
    id: 'baseInfo',
    title: '添加博物馆专家组',
    footerShow:'special',
    data: [
      {
        id: 'name',
        name: '组名',
        placeholder: '请输入组名',
        type: 'input',
        checkType: 'required',
        tips:'',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'name'
      },
      {
        id: 'levelids',
        name: '博物馆质量等级',
        placeholder: '请选择博物馆质量等级',
        type: 'checkbox',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        tips:'',
        options: [],
        expand: {},
        jpath: 'levelids'
      },
      {
        id: 'indicatorids',
        name: '评估指标',
        placeholder: '请选择评估指标',
        type: 'radio',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        tips:'',
        options: [
          {
            value: '1',
            name: '规范管理'
          },
          {
            value: '2',
            name: '服务产出'
          },
          {
            value: '3',
            name: '社会评价'
          }
        ],
        expand: {},
        jpath: 'indicatorids'
      },
    ]
  }
];
